const timeSegments: number[] = [
  3.154e10,
  2.628e9,
  6.048e8,
  8.64e7,
  3.6e6,
  60000,
  -Infinity,
]

const makeTimeString = (unit: string, singularString: string) => (timeSegment: number, time: number): string =>
  (time >= 2 * timeSegment
    ? `${Math.floor(time / timeSegment)} ${unit}s`
    : singularString) + " ago"

const timeFunctions: Function[] = [
  makeTimeString('year', '1 year'),
  makeTimeString('month', '1 month'),
  makeTimeString('week', '1 week'),
  makeTimeString('day', '1 day'),
  makeTimeString('hour', 'an hour'),
  makeTimeString('minute', 'a minute'),
  () => 'just now',
]

const timeConverter = (timeStamp: number):string => {
  const timeDifference: number = Math.abs(Date.now() - timeStamp)
  const index: number = timeSegments.findIndex(time => timeDifference >= time)
  const timeAgo: string = timeFunctions[index](timeSegments[index], timeDifference)
  return (Date.now() > timeStamp)? timeAgo : "in " + timeAgo.replace(" ago", "") // workaround to handle the case of 'just now'
}

const timeConverterAfterYear = (timeStamp: number): string => {
  const a = new Date(Number(timeStamp))
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
  const year = a.getFullYear()
  const month = months[a.getMonth()]
  const date = a.getDate()
  return `${month} ${date}, ${year}`
}

export const getTimeAgo = (timeStamp: number): string => {
  const yearTime:number = 31536000 * 1000
  return ((Date.now() - timeStamp) > yearTime) ? timeConverterAfterYear(timeStamp) : timeConverter(timeStamp)
}